import { XVII18nService } from '@app/i18n/services';
import { I18n } from '@app/i18n/strings-keys';
import { gt, size } from 'lodash';

const getSiteSelectorButtonCaption = (captionOptions: {
  items: [];
  i18nService: XVII18nService;
}): string => {
  const itemsLength = size(captionOptions.items);
  const isMultiple = gt(itemsLength, 1);
  const i18nKey = isMultiple
    ? I18n.Common.SelectXEntities
    : I18n.Common.SelectEntities;
  const translatedSites = captionOptions.i18nService.instant(
    I18n.EntityNames.SiteSingularAndPlural,
  );
  const params = isMultiple
    ? { count: itemsLength, entities: translatedSites }
    : { entities: translatedSites };

  return captionOptions.i18nService.instant(i18nKey, params);
};

export { getSiteSelectorButtonCaption };
